export default "__VITE_ASSET__Bg9p2o_t__"